import store from '../store';

const track = (selector, type) => {
  const containers = document.querySelectorAll(selector);

  const render = (values) => {
    containers.forEach((c) => {
      if (values.length === 0) {
        c.style.display = 'none';
        c.innerHTML = '';
      } else {
        c.style.display = 'flex';
        c.innerHTML = values.length;
      }
    });
  };

  render(store.getState().prod[type]);
  store.subscribe(() => {
    render(store.getState().prod[type]);
  });
};

const Icons = () => {
  track('.fav', 'favour');
  track('.crt', 'cart');
  track('.cmpr', 'compare');
};

export default Icons;
